module.exports = __webpack_public_path__ + "static/haveX86.b6d6e691.png";